module.exports = __webpack_public_path__ + "static/media/game_music_zen_arpeggios.9d825d16.mp3";